/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AreaFilterContext
 */
export interface AreaFilterContext {
    /**
     * 
     * @type {string}
     * @memberof AreaFilterContext
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof AreaFilterContext
     */
    stateAbbreviated?: string;
}

/**
 * Check if a given object implements the AreaFilterContext interface.
 */
export function instanceOfAreaFilterContext(value: object): value is AreaFilterContext {
    return true;
}

export function AreaFilterContextFromJSON(json: any): AreaFilterContext {
    return AreaFilterContextFromJSONTyped(json, false);
}

export function AreaFilterContextFromJSONTyped(json: any, ignoreDiscriminator: boolean): AreaFilterContext {
    if (json == null) {
        return json;
    }
    return {
        
        'city': json['city'] == null ? undefined : json['city'],
        'stateAbbreviated': json['stateAbbreviated'] == null ? undefined : json['stateAbbreviated'],
    };
}

export function AreaFilterContextToJSON(json: any): AreaFilterContext {
    return AreaFilterContextToJSONTyped(json, false);
}

export function AreaFilterContextToJSONTyped(value?: AreaFilterContext | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'city': value['city'],
        'stateAbbreviated': value['stateAbbreviated'],
    };
}

